import { createFileRoute } from '@tanstack/react-router';

import { WorkspacePractitionerListScreen } from '@/features/practitioners/components/workspace/PractitionerListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/practitioners/')({
  beforeLoad: () => {
    requirePermission('practitioner:read');
  },
  component: WorkspacePractitionerListScreen,
  staticData: { crumb: 'Practitioners' },
});
